const getters = {
  getVariables: (state) => state.variables,
};

export default getters;
